import { REGIONS } from "../components/syndication/constants/constants";

export const TRANSLATIONS = {
  [REGIONS.EMEA]: {
    Source: "Source",
    lower: "lower",
    higher: "higher",
    Unchanged: "Unchanged",
    "Last Close Date": "Last Close Date",
    "Previous Close Date": "Previous Close Date",
    "Reference Market": "Reference Market",
    "Contract Month": "Contract Month",
    "Settlement Price": "Settlement Price",
    "% Change": "% Change",
    "Fund Position": "Fund Position",
    "Net Contracts": "Net Contracts",
    "Weekly Change": "Weekly Change",
    "Weekly % Changes": "Weekly % Changes",
    "Previous Week Market close": "Previous Week Market close",
    region: "EMEA",
    Cocoa: "Cocoa",
    "Cocoa London": "Cocoa London",
    "Cocoa New York": "Cocoa New York",
  },
  [REGIONS.NA]: {
    Source: "Source",
    lower: "lower",
    higher: "higher",
    Unchanged: "Unchanged",
    "Last Close Date": "Last Close Date",
    "Previous Close Date": "Previous Close Date",
    "Reference Market": "Reference Market",
    "Contract Month": "Contract Month",
    "Settlement Price": "Settlement Price",
    "% Change": "% Change",
    "Fund Position": "Fund Position",
    "Net Contracts": "Net Contracts",
    "Weekly Change": "Weekly Change",
    "Weekly % Changes": "Weekly % Changes",
    "Previous Week Market close": "Previous Week Market close",
    "Previous Market close": "Previous Market close",
    region: "North America",
    Cocoa: "Cocoa",
    "Cocoa London": "Cocoa London",
    "Cocoa New York": "Cocoa New York",
  },
  [REGIONS.SA]: {
    Source: "Source",
    lower: "lower",
    higher: "higher",
    Unchanged: "Unchanged",
    "Last Close Date": "Last Close Date",
    "Previous Close Date": "Previous Close Date",
    "Reference Market": "Reference Market",
    "Contract Month": "Contract Month",
    "Settlement Price": "Settlement Price",
    "% Change": "% Change",
    "Fund Position": "Fund Position",
    "Net Contracts": "Net Contracts",
    "Weekly Change": "Weekly Change",
    "Previous Week Market close": "Previous Week Market close",
    region: "South America",
    Cocoa: "Cocoa",
    "Cocoa London": "Cocoa London",
    "Cocoa New York": "Cocoa New York",
  },
  [REGIONS.SA_PG]: {
    Source: "Fonte",
    lower: "Mais baixo",
    higher: "Mais alto",
    Unchanged: "Sem mudanças",
    "Last Close Date": "Última data de fechamento",
    "Previous Close Date": "Data de fechamento anterior",
    "Reference Market": "Mercado de referência",
    "Contract Month": "Mês do contrato",
    "Settlement Price": "Preço do fechamento",
    "% Change": "% de variação",
    "Fund Position": "Posição dos fundos",
    "Net Contracts": "Contratos Net",
    "Weekly Change": "Mudança Semanal",
    "Weekly % Changes": "mudança % semanal",
    "Previous Week Market close": "Fechamento da semana anterior",
    region: "América do Sul",
    Cocoa: "Cacau",
    "Cocoa London": "Cacau Londres",
    "Cocoa New York": "Cacau Nova Iorque",
  },
  [REGIONS.SA_ES]: {
    Source: "Fuente",
    lower: "Más bajo",
    higher: "Más alto",
    Unchanged: "Sin alterar",
    "Last Close Date": "Datos del último cierre",
    "Previous Close Date": "Datos de cierres anteriores",
    "Reference Market": "Mercado de referencia",
    "Contract Month": "Mes de contrato",
    "Settlement Price": "Precio de liquidación",
    "% Change": "% de cambio",
    "Fund Position": "Posición del fondo",
    "Net Contracts": "Contratos netos",
    "Weekly Change": "Cambio Semanal",
    "Weekly % Changes": "Cambio % semanal",
    "Previous Week Market close": "Cierre de mercado semana anterior",
    region: "Sudamerica",
    Cocoa: "Cacao",
    "Cocoa London": "Cacao Londres",
    "Cocoa New York": "Cacao Nueva York",
  }, //need to again filter it once done
  [REGIONS.NA_MX_ES]: {
    Source: "Fuente",
    lower: "Más bajo",
    higher: "Mas alto",
    Unchanged: "Sin cambio",
    "Weekly Market Report": "Reporte de mercado semanal",
    "Last Close Date": "Datos del último cierre",
    "Previous Close Date": "Datos del cierre anteriores",
    "Reference Market": "Mercado de referencia",
    "Contract Month": "Mes de contrato",
    "Settlement Price": "Precio de liquidación",
    "% Change": "% de cambio",
    "Fund Position": "Posición del fondo",
    "Net Contracts": "Contratos netos",
    "Weekly Change": "Cambio Semanal",
    "Weekly % Changes": "Cambio % semanal",
    "Daily % change": "Cambio % diario",
    "Previous Week Market close": "Cierre de mercado semana anterior",
    region: "Norteamérica",
    Cocoa: "Cocoa",
    "Cocoa London": "Cocoa London",
    "Cocoa New York": "Cocoa New York",
  },
};
